import { IconButton } from '@chakra-ui/react'
import { ComponentProps } from 'react'
import { MdThumbDown, MdThumbDownOffAlt, MdThumbUp, MdThumbUpOffAlt } from 'react-icons/md'

import { IThumbButtonProps } from '@/types/gigiChat/Feedback'

const ThumbButton = ({
    ariaLabel = 'Thumb button',
    fontSize = '20px',
    type = 'up',
    isSelected = false,
    isLoading = false,
    onClick,
}: IThumbButtonProps) => {
    let variant: ComponentProps<typeof IconButton>['variant'] = 'feedback'
    let icon = <MdThumbUp />

    if (type === 'down') {
        icon = <MdThumbDownOffAlt />

        if (isSelected) {
            icon = <MdThumbDown />
            variant = 'negativeFeedback'
        }
    } else if (type === 'up') {
        icon = <MdThumbUpOffAlt />

        if (isSelected) {
            icon = <MdThumbUp />
            variant = 'positiveFeedback'
        }
    }

    return (
        <IconButton
            variant={variant}
            aria-label={ariaLabel}
            fontSize={fontSize}
            rounded="full"
            loading={isLoading}
            onClick={onClick}
            mr="12px"
            data-testid={`thumb-${type}-button`}
        >
            {icon}
        </IconButton>
    )
}

export default ThumbButton
